import { Component, OnInit, AfterViewInit, AfterContentChecked, ViewChild, Output, EventEmitter, } from "../../../../node_modules/@angular/core";
import { ToastrService } from "ngx-toastr";
import { DatePipe, JsonPipe } from "@angular/common";
import { CookieService } from "ngx-cookie-service";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient } from '@angular/common/http';
import { ScriptLoaderService } from "../../_services/script-loader.service";
import { appService } from "../../_services/app.service";
import { CommonService } from "../../_services/common.service";
import { environment } from "../../../environments/environment";
import { Helpers } from "../../helpers";
import { NavService } from "../../_services/NavService.service";
import { PaymentRequestComponent } from "../payment-request/payment-request.component";
import { DocumentsComponent } from "../../../app/documentshared/documents.component";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { NetworkComponent } from "../../../app/Network/network/network.component";
import { DecryptPipe } from "../../auth/_services/encrypt-decrypt.pipe";
import { data } from "jquery";
const LNG_KEY = "SELECTED_LANGUAGE";
//pawan
declare var moment: any;
declare var $: any;

@Component({
  selector: "app-payment-made",
  templateUrl: "./payment-made.component.html",
})
export class PaymentMadeComponent implements OnInit, AfterViewInit {
  @Output() LoadPaymentReuest = new EventEmitter<string>();
  selectedLang: string;
  CompanyId: any;
  TenantId: any;
  static that: PaymentMadeComponent;
  VendorId: any;
  PrintPaymentHeaderObj: any = {};
  PrintPaymentDetails: any = [];

  //Add kevin for detail report 08/04/2020
  PrintDetailPaymentHeaderObj: any = {};
  PrinDetailPaymentDetails: any = [];

  PendingBillList: any = [];
  AccountData: any = {};
  showPaymentMadeList: boolean = true;
  showPaymentMadeDetails: boolean = false;

  datatable: any;
  datatableForPendingBill: any;

  PaymentModes: any = [];
  PaymentMadeToAccountData: any = [];
  //---------------------
  DashboardData: any = {};
  VendorDetail: any = {};
  PaymentData: any = {};
  PaymentDetail: any = [];
  PaymentId: any;
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedComapnyEmail: any;
  SelectedCompanyPhone: any;
  SelectedCompanyLogo: any;

  SubTotalBillAmount: any;
  SubTotalPaidAmount: any;
  SubTotalAmountDue: any;
  SubTotalPaymentAmount: any;
  SubTotalTDS: any;
  IsAuthorized: any = false;
  IsPosted: any = false;

  DownloadFromDate: any;
  DownloadToDate: any;
  GetCountForPettyCash: any;
  AccountDetail: any = {};
  selectedCard: any = "Draft";
  JVSummaryData: any = [];
  paymentMode: string;
  TDSRates: any = [];

  ShowAttachment: any = false;
  payFull: any = false;

  PrintTHCArray: any = [];
  PrintTHC: any;

  //add kevin 09/08/2020
  userId: any;
  //end

  //add siddharth 25/06/2021
  AuditTrailData: any = [];
  //end
  isMainPage: boolean = true;
  BankStatementId: any;

  @ViewChild(DocumentsComponent) AttachmentChild: DocumentsComponent;

  //add vithujan 06-07-2022
  isDelete: boolean = false;
  //end
  //added by vithujan 10-01-2023
  contextmenu: any = false;
  contextmenuX: any = 0;
  contextmenuY: any = 0;
  //end
  //added by vithujan 25-01-2023
  FinancialYearArray: any = [];
  //end
  //added by vithujan 06-02-02023
  TransactionType: any = "";
  ModalType: any = "";
  rowIndex = -1;
  totalRowsCount: any = 0;
  //end
  //added by vithujan 20-04-2023
  isFromAnotherPage: boolean = false;
  BankStatementData: any = {};
  //end
  //added by vithujan 24-04-2023
  hostURL: any = environment.apiUrl;
  //hostURL: any = 'https://infinity.ifreightbox.net/';
  //end
  isShowOtherModel: any = "NO";
  isShowParentClose: any = true;

  fromPaymentList: any = "false";

  AdvancePaymentFile: any = {};

  @ViewChild(NetworkComponent) ChildNetworkComponent: NetworkComponent;
  constructor(
    private _script: ScriptLoaderService,
    private _appService: appService,
    private commonService: CommonService,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private _navService: NavService,
    private route: ActivatedRoute,
    private router: Router,
    private service: TranslateConfigService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private httpService: HttpClient,
    private decryptpipe: DecryptPipe
  ) {
    PaymentMadeComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    var Id = "";
    this.route.params.subscribe((params) => {
      Id = params["Id"];
    });

    this.SelectedComapnyName = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedComapnyName;
    this.SelectedCompanyAdd = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyAdd;
    this.SelectedCompanyCIN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyCIN;
    this.SelectedCompantGSTIN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompantGSTIN;
    this.SelectedComapnyEmail = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedComapnyEmail;
    this.SelectedCompanyPhone = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyPhone;
    this.SelectedCompanyLogo = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).CompanyLogoPath;
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    //add kevin 09/08/2020
    this.userId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    //end

    this.GetBillPaymentList();
    this.ClearDashboardData();
    // added by vithujan 06-02-2023
    this.showHelpMenu();
    //end
    this.LoadICICIBankPaymentAllowed();
    this.GetTransactionTypes();

    if (Id != "list" && Id != undefined && Id != "" && Id != null) {
      this.showPaymentMadeList = false;
      this.showPaymentMadeDetails = true;
      this.GetBillPaymentById(Id);
      if (this.commonService.CheckHasRight("EDIT", "PAYMENTMADE_DETAILS")) {
        $("#BtnBillPaymentSave").css("display", "inline-block");
      } else {
        $("#BtnBillPaymentSave").css("display", "none");
      }
    }
  }

  ICICIBankPaymentAllowed: boolean = false;
  LoadICICIBankPaymentAllowed() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "ICICIBankPaymentAllowed")
      .subscribe(
        (response) => {
          if (response == '1') {
            this.ICICIBankPaymentAllowed = true;
          } else {
            this.ICICIBankPaymentAllowed = false;
          }
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.GetPaymentModes();
      this.GetTDSList();
      this.GetSelectData();
      this.RefreshvalidDate();
      this.RefreshDropDown();
      this._navService.navItem$.subscribe((item) => {
        if (window.location.pathname == "/PaymentMade/list") {
          this.SelectedComapnyName = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyName;
          this.SelectedCompanyAdd = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyAdd;
          this.SelectedCompanyCIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyCIN;
          this.SelectedCompantGSTIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompantGSTIN;
          this.SelectedComapnyEmail = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyEmail;
          this.SelectedCompanyPhone = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyPhone;
          this.SelectedCompanyLogo = JSON.parse(localStorage.getItem("ChnageCompnayId")).CompanyLogoPath;
          $("#logoimg").attr("src", environment.apiUrl + this.SelectedCompanyLogo);
          this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;

          this.ClearDashboardData();
          if (this.datatable) {
            this.datatable.destroy();
          }
          this.GetBillPaymentList();
        }
      });
      $("#PaymentAttchment").on("shown.bs.modal", function () {
        PaymentMadeComponent.that.OnAttachmentClick();
      });

      //added by vtihujan 25-01-2023
      this.RefreshvalidDateModal();
      $("#SalesInvoiceAdvanceSearch").on("shown.bs.modal", function () {
        PaymentMadeComponent.that.GetPaymentNoByCompany();
        PaymentMadeComponent.that.GetCustomerVendorSelect2Data();
        PaymentMadeComponent.that.GetTHCNoByCompany();
        PaymentMadeComponent.that.GetPaidThrough();
        PaymentMadeComponent.that.GetAccountingYear();
      });
      //end
    }, 1500);
  }

  RefreshDropDown() {
    setTimeout(() => {
      (<any>$("#BillsPaymentMode")).selectpicker("refresh");
      (<any>$("#TDSRates11")).selectpicker("refresh");
      (<any>$("#TransactionType")).selectpicker("refresh");
      //  (<any>$("#SelectPaymentToAccount1")).selectpicker("refresh");
    }, 300);
  }

  // ----------------------------Initialize Datepicker----------------------
  RefreshvalidDate() {
    setTimeout(() => {
      $(".datepicker1").datepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "dd/mm/yyyy",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
    }, 200);
  }

  GetFormattedDate(Id, ScopeValue) {
    if (
      moment($("#" + Id).datepicker("getDate")).format("YYYY-MM-DD") !=
      "Invalid date"
    ) {
      ScopeValue = moment($("#" + Id).datepicker("getDate")).format(
        "YYYY-MM-DD"
      );
    } else {
      var date = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
      if (date.test(ScopeValue)) {
        var d = new Date(ScopeValue.split("/").reverse().join("-"));
        ScopeValue = this.datepipe.transform(d, "yyyy-MM-dd");
      }
    }
    return ScopeValue;
  }

  GetTDSList() {
    this._appService.Get("Sales", "GetTDSList").subscribe(
      (response) => {
        this.TDSRates = response;
        setTimeout(() => {
          (<any>$("#TDSRates11")).selectpicker("refresh");
        }, 300);
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Status data !",
          "error"
        );
      }
    );
  }
  //----------------------------------------------------------------------

  SearchStatus(Status) {
    this.selectedCard = Status;
    if (this.datatable) this.datatable.search(Status, "Status");
    else this.GetBillPaymentList();

    //added by vithujan 20-02-2023
    setTimeout(() => {
      var rows = PaymentMadeComponent.that.datatable;
      rows.rows(".m-datatable__row");
      PaymentMadeComponent.that.totalRowsCount = rows.nodes().length;
      PaymentMadeComponent.that.rowIndex = -1;
    }, 2000);
    //end
  }
  ClearDashboardData() {
    this.DashboardData.DraftCount = 0;
    this.DashboardData.AuthorizedCount = 0;
    this.DashboardData.PostedCount = 0;
    this.DashboardData.DeletedCount = 0;
  }

  //------------------------------New /Go Back----------------------------
  OnNewPayment(mode) {
    //add by maaria
    this.fromPaymentList = "true";
    //end
    this.paymentMode = mode;
    this.showPaymentMadeList = false;
    this.showPaymentMadeDetails = true;
    this.IsAuthorized = false;
    this.IsPosted = false;
    this.PaymentMadeToAccountData = [];
    this.ShowAttachment = false;
    this.VendorDetail = {};
    this.PaymentData = {};
    this.PaymentDetail = [];
    (<any>$("#SelectPaymentToAccount1")).selectpicker("refresh");
    $(".PaymentMadeVendor").val("");
    $(".PaymentMadeVendor").select2("destroy");
    $(".PaymentAccount").val("");
    $(".THCNo").val("");
    $(".PaymentAccount").select2("destroy");
    this.GetSelectData();
    $("#SelectPaymentAccount").prop("disabled", true);
    $("#SelectPaymentToAccount1").prop("disabled", true);
    $("#Pettycashlink").css("display", "none");
    $("#PaymentDate").datepicker("setDate", new Date());
    $("#BtnBillPaymentSave").prop("disabled", false);
    $(".ClsAddBill").prop("disabled", false);
    // $("#BtnBillPaymentAuthorize").prop("disabled", true);
    $(".btnAuth").prop("disabled", true);
    // $("#BtnBillPaymentPost").prop("disabled", true);
    $(".btnPost").prop("disabled", true);
    $("#BtnPrint").prop("disabled", true);
    $("#BtnPrintDetail").prop("disabled", true);
    if (mode == "againstBill") {
      if (
        PaymentMadeComponent.that.commonService.CheckHasRight(
          "ADD",
          "PAYMENTMADE_DETAILS"
        )
      ) {
        $("#BtnBillPaymentSave").css("display", "inline-block");
        $(".ClsAddBill").prop("disabled", false);
        $("#BillNumber").prop("disabled", false);
        $("#BtnAddBill").prop("disabled", false);
      } else {
        $("#BtnBillPaymentSave").css("display", "none");
      }
    }
    if (mode == "advancePayment") {
      if (
        PaymentMadeComponent.that.commonService.CheckHasRight(
          "ADD",
          "PAYMENTREQUEST_DETAILS"
        )
      ) {
        $("#BtnBillPaymentSave").css("display", "inline-block");
      } else {
        $("#BtnBillPaymentSave").css("display", "none");
      }

      $(".ClsAddBill").prop("disabled", true);
      $("#BillNumber").prop("disabled", true);
      $("#BtnAddBill").prop("disabled", true);
    }
    //added by vithujan 23-02-2023
    setTimeout(() => {
      document.getElementById("SelectPaymentMadeVendor").focus();
    }, 100);
    //end
  }

  OnGoBack() {
    // this.paymentMode = 'close';
    //added by maaria
    localStorage.removeItem("fromPaymentList");
    this.fromPaymentList = "false";
    //end
    this.showPaymentMadeList = true;
    this.showPaymentMadeDetails = false;
    this.RefreshElements();
  }
  RefreshElements() {
    this.IsAuthorized = false;
    this.IsPosted = false;
    $("#PaymentMadeDraft").css("border", "0px");
    $("#PaymentMadeAuthorized").css("border", "0px");
    $("#PaymentMadePosted").css("border", "0px");
    this.ClearDashboardData();
    if (this.datatable) this.datatable.destroy();
    this.GetBillPaymentList();
    this.PaymentMadeToAccountData = [];
    (<any>$("#SelectPaymentToAccount1")).selectpicker("refresh");
    this.VendorDetail = {};
    this.PaymentData = {};
    this.PaymentDetail = [];
    $("#PaymentDate").val("");
    $("#ClearDate").val("");
    $(".PaymentMadeVendor").val("");
    $(".PaymentAccount").val("");
    $(".PaymentMadeVendor").select2("destroy");
    $(".PaymentAccount").select2("destroy");
    //  $("#TDSRates").val("NA");

    this.GetSelectData();
    this.RefreshDropDown();
    this.ClearValidation();

    this.SearchStatus(this.selectedCard);

    $("#btnShowPaymentJVDetails").addClass("fa-plus");
    $("#btnShowPaymentJVDetails").removeClass("fa-minus");
    $("#ShowJVPaymentDetails").css("display", "none");
    $("#btnShowAuditTrail_bp").addClass("fa-plus");
    $("#btnShowAuditTrail_bp").removeClass("fa-minus");
    $("#btnShowBankApiLog_bp").addClass("fa-plus");
    $("#btnShowBankApiLog_bp").removeClass("fa-minus");
    $("#ShowAuditTrail_bp").css("display", "none");
    $("#ShowBankApiLog_bp").css("display", "none");
    this.JVSummaryData = [];
    if (this.paymentMode == "advancePayment") this.LoadPaymentReuest.emit();
    else this.router.navigate(["/PaymentMade", "list"]);
  }
  //----------------------------------------------------------------------
  GetPaymentModes() {
    this._appService
      .GetById("Common", "GetLookByCategoryName", "PaymentMode")
      .subscribe(
        (response) => {
          // this.PaymentModes = response;
          this.PaymentModes = [
            ...response.filter((arr) => arr.Label !== "Creditors or Vendors"),
          ];
          setTimeout(() => {
            (<any>$("#BillsPaymentMode")).selectpicker("refresh");
            //  (<any>$("#SelectPaymentToAccount1")).selectpicker("refresh");
          }, 300);
          //     this.RefreshDropDown();
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  GetSelectData() {
    // alert(1)
    $(".PaymentMadeVendor").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetVendorName",
        headers: {
          "Authorization": PaymentMadeComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            TenantId: PaymentMadeComponent.that.TenantId,
            Type: "Bills",
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      /// tokenSeparators: [","],  comment by rahul data not loading 06-06-2024

      placeholder: "Search for Vendor",
    });

    $(".PaymentMadeVendor").on("select2:select", function (e) {
      var data = e.params.data;
      PaymentMadeComponent.that.VendorDetail = data;
      PaymentMadeComponent.that.PaymentData.VendorId = data.id;
      PaymentMadeComponent.that.PaymentData.PANNo = data.PANNumber;
      let Id = data.TDS + "__" + data.TDSRate;
      $("#TDSRates11").val(Id);
      PaymentMadeComponent.that.RefreshDropDown();
      PaymentMadeComponent.that.CalculateNetAmounts(true);
      PaymentMadeComponent.that.GetBankAccountDetailsByCompanyId();
      $("#SelectPaymentToAccount1").prop("disabled", false);
      PaymentMadeComponent.that.get_IsCompanyDisable(data.id);
    });

    $(".PaymentAccount").select2({
      tags: true,
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Sales/GetAccountsByPaymentMode",
        headers: {
          "Authorization": PaymentMadeComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            Type: PaymentMadeComponent.that.PaymentData.PaymentType,
            CompanyId: PaymentMadeComponent.that.CompanyId,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],
      createTag: function (params) {
        $(".select2-search__field").keydown(function (e) {
          if (e.keyCode != 32) {
            var term = $.trim(params.term);
            // Don't offset to create a tag if there is no valid email
            return {
              id: term,
              text: term,
              newTag: true, // add additional parameters
            };
          }
        });
      },
      insertTag: function (data, tag) {
        data.push(tag);
      },
      placeholder: "Enter Account Name",
    });

    $(".PaymentAccount").on("select2:select", function (e) {
      var data = e.params.data;
      let index = e.target.id.split("_")[1];
      PaymentMadeComponent.that.PaymentData.PaidFromAccountId = data.id;
      PaymentMadeComponent.that.PaymentData.PaidFromAccountName = data.text;
    });

    // $('.PaymentToAccount').select2({
    //     tags: false,
    //     width: "100%",
    //     escapeMarkup: function (markup) { return markup; },
    //     minimumInputLength: 2,
    //     ajax: {
    //         global: false,
    //         url: environment.apiUrl + "api/Sales/GetBankAccountDetailsByCompanyId",
    //         delay: 300,
    //         dataType: 'json',
    //         allowClear: true,
    //         data: function (params) {
    //             return {
    //                 query: params.term,
    //                 page: params.page || 1,
    //                 Type: "PaymentMade",
    //                 CompanyId: PaymentMadeComponent.that.PaymentData.VendorId,
    //             };
    //         },
    //         processResults: function (data, params) {
    //             params.page = params.page || 1;
    //             return {
    //                 results: data.Results,
    //                 pagination: {
    //                     more: (params.page * 30) < data.Total
    //                 }
    //             };
    //         },
    //     },
    //     tokenSeparators: [',', ' '],
    //     createTag: function (params) {
    //         var term = $.trim(params.term);
    //         // Don't offset to create a tag if there is no valid email
    //         return {
    //             id: term,
    //             text: term,
    //             newTag: true // add additional parameters
    //         }
    //     },
    //     insertTag: function (data, tag) {
    //         data.push(tag);
    //     },
    //     placeholder: 'Enter Bank/Branch Name'
    // });

    // $('.PaymentToAccount').on('select2:select', function (e) {
    //     var data = e.params.data;
    //     PaymentMadeComponent.that.PaymentData.PaidToAccountId = data.id;
    // });

    $("#SelectTHC").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetThcNo",
        headers: {
          "Authorization": PaymentMadeComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            TranspoterId: PaymentMadeComponent.that.PaymentData.VendorId,
            Type: PaymentMadeComponent.that.VendorDetail.Type,
            GetType: "GetOpen",
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],

      placeholder: "Search for THC",
    });

    $("#SelectTHC").on("select2:select", function (e) {
      var data = e.params.data;
      PaymentMadeComponent.that.PaymentData.ExpectedBillAmount =
        data.TotalTruckHireCharge;
      PaymentMadeComponent.that.PaymentData.VehicleNo = data.VehicleNo;
      PaymentMadeComponent.that.PaymentData.VehicleSize = data.VehicleSize;
      PaymentMadeComponent.that.PaymentData.PaidWeight = data.PaidWeight;
    });
  }

  GetBankAccountDetailsByCompanyId() {
    this._appService
      .GetByTwoId(
        "Sales",
        "GetBankAccountDetailsByCompanyId",
        "PaymentReceipt",
        this.PaymentData.VendorId
      )
      .subscribe(
        (response) => {
          this.PaymentMadeToAccountData = response;
          setTimeout(() => {
            (<any>$("#SelectPaymentToAccount1")).selectpicker("refresh");
          }, 100);
        },
        (err) => {
          this.toastr.error("Error occurred while Bank Accounts !", "error");
        }
      );
  }

  CreateNewAccount() {
    if (
      this.commonService.ValidateRequiredField2(
        $("#SelectPaymentMadeVendor"),
        $("#FieldsetNewCharge"),
        "Please Select Vendor / Driver",
        "after",
        ""
      )
    ) {
      this.AccountDetail = {};
      this.ClearValidationsForBankDetails();
      $("#AddPaidToModal").modal("show");
    } else {
      this.toastr.error("Please Select Vendor !", "Error");
    }
  }

  SavePaidToAccount() {
    Helpers.setLoading(true);
    var flag = this.ValidateBankDetailsField();
    if (flag != false) {
      if (this.VendorDetail.Type != "Driver") {
        this.AccountDetail.CompanyId = this.PaymentData.VendorId;
        this._appService
          .Post("Network", "SaveCompanyAccountDetail", this.AccountDetail)
          .subscribe(
            (response) => {
              $("#AddPaidToModal").modal("hide");
              this.GetBankAccountDetailsByCompanyId();
              Helpers.setLoading(false);
              this.toastr.success(
                "Bank details saved Successfully !",
                "Success"
              );
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("Error occurred while saving data !", "error");
            }
          );
      } else {
        this.AccountDetail.DriverId = this.PaymentData.VendorId;
        this._appService
          .Post("DriverMaster", "SaveDriverAccountDetail", this.AccountDetail)
          .subscribe(
            (response) => {
              $("#AddPaidToModal").modal("hide");
              this.GetBankAccountDetailsByCompanyId();
              Helpers.setLoading(false);
              this.toastr.success(
                "Bank details saved Successfully !",
                "Success"
              );
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("Error occurred while saving data !", "error");
            }
          );
      }
    } else {
      Helpers.setLoading(false);
      const FillRequiredDetails = this.translate.instant(
        "ALERTMESSAGES.FillRequiredDetails"
      );
      this.toastr.error(FillRequiredDetails, "error");
    }
  }
  ValidateBankDetailsField() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField(
        $("#AccountNoForPayment"),
        "Please Enter Account No",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#BankForPayment"),
        "Please Enter Bank",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#BranchForPayment"),
        "Please Enter Branch",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#IFSCCodeForPayment"),
        "Please Enter IFSC Code",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    return flag;
  }

  ClearValidationsForBankDetails() {
    this.commonService.ClearMessage($("#AccountNoForPayment"));
    this.commonService.ClearMessage($("#BankForPayment"));
    this.commonService.ClearMessage($("#BranchForPayment"));
    this.commonService.ClearMessage($("#IFSCCodeForPayment"));
  }

  //-----------------------------Datatable--------------------------
  GetBillPaymentList() {
    this.datatable = (<any>$("#m_datatable_PaymentMade")).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/BillPayment/GetBillPaymentList",
            params: {
              // custom parameters
              CompanyId: PaymentMadeComponent.that.CompanyId,
              //added by vithujan 26-01-2023
              BillNos:
                $("#SelectBillList").val().join(",") == ""
                  ? null
                  : $("#SelectBillList").val().join(","),
              VendorId:
                $("#CompanyData").val().join(",") == ""
                  ? null
                  : $("#CompanyData").val().join(","),
              AccountNo:
                $("#AccountNo").val().join(",") == ""
                  ? null
                  : $("#AccountNo").val().join(","),
              THCNo:
                $("#SelectTHCTripNo").val().join(",") == ""
                  ? null
                  : $("#SelectTHCTripNo").val().join(","),
              fromDate:
                this.GetFormattedDate(
                  "InvoiceFromDate",
                  $("#InvoiceFromDate").val()
                ) == ""
                  ? null
                  : this.GetFormattedDate(
                    "InvoiceFromDate",
                    $("#InvoiceFromDate").val()
                  ),
              toDate:
                this.GetFormattedDate(
                  "InvoiceToDate",
                  $("#InvoiceToDate").val()
                ) == ""
                  ? null
                  : this.GetFormattedDate(
                    "InvoiceToDate",
                    $("#InvoiceToDate").val()
                  ),
              Financialyear:
                $("#id_ddlFinancialyear").val() == ""
                  ? null
                  : $("#id_ddlFinancialyear").val(),
            },
            headers: {
              "Authorization": PaymentMadeComponent.that._appService.getAuthToken(),
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100, 500, 1000],
          },
        },
      },
      search: {
        onChange: true,
        input: $("#SearchValue"),
        delay: 400,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          let flag = 0;
          if (flag == 0) {
            PaymentMadeComponent.that.DashboardData.DraftCount =
              data.DraftCount;
            PaymentMadeComponent.that.DashboardData.AuthorizedCount =
              data.AuthorizedCount;
            PaymentMadeComponent.that.DashboardData.PostedCount =
              data.PostedCount;
            //add vithujan 05-07-2022
            PaymentMadeComponent.that.DashboardData.DeletedCount =
              data.DeletedCount;
            //end
            flag = 1;
          }
          $(row)
            .find(".btnEdit")
            .click(function () {
              localStorage.setItem("fromPaymentList", "true");
              PaymentMadeComponent.that.showPaymentMadeList = false;
              PaymentMadeComponent.that.showPaymentMadeDetails = true;
              PaymentMadeComponent.that.GetBillPaymentById(data.Id);
            });
          $(row)
            .find(".btnDelete")
            .click(function () {
              var Id = $(this).attr("Id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  PaymentMadeComponent.that.DeleteBillPaymentById(Id, "List");
                }
              });
            });
          // },
        },
      },
      columns: [
        {
          field: "PaymentNumber",
          title: this.selectedLang == "sp" ? "Número de pago" : "Payment#",
          sortable: false,
          width: 150,
          textAlign: "left",
          template: function (t) {
            var btn = "";
            if (
              PaymentMadeComponent.that.commonService.CheckHasRight(
                "VIEW",
                "PAYMENTMADE_DETAILS"
              )
            ) {
              if (t.IsAdvancePayment) {
                btn +=
                  '<a id="' +
                  t.Id +
                  '" style="color:#2088d8;font-size:14px;cursor:pointer;"  class="btnEdit" title="Edit details">' +
                  t.PaymentNumber +
                  ' <i class="fa fa-money"  title="Advance Payment"></i></a>';
              } else {
                btn +=
                  '<a id="' +
                  t.Id +
                  '" style="color:#2088d8;font-size:14px;cursor:pointer;"  class="btnEdit" title="Edit details">' +
                  t.PaymentNumber +
                  "</a>";
              }
              //
            } else {
              var btn = "<span>" + t.PaymentNumber + "</span>";
            }
            return btn;
          },
        },
        {
          field: "PaymentDate",
          title: this.selectedLang == "sp" ? "Fecha de pago" : "Payment Date",
          sortable: false,
          width: 180,
          textAlign: "center",
        },
        {
          field: "VendorName",
          title: this.selectedLang == "sp" ? "Vendedor" : "Vendor",
          sortable: false,
          width: 180,
          textAlign: "left",
        },
        {
          field: "THCNo",
          title: this.selectedLang == "sp" ? "Número de Reserva" : "THC NO",
          sortable: false,
          width: 180,
          textAlign: "left",
        },
        {
          field: "Account",
          title: this.selectedLang == "sp" ? "Cuenta" : "Account",
          filterable: !1,
          width: 180,
        },
        {
          field: "PaymentMode",
          title: this.selectedLang == "sp" ? "Modo" : "Mode",
          filterable: !1,
          width: 180,
        },
        {
          field: "PaidAmount",
          title: this.selectedLang == "sp" ? "Monto pagado" : "Paid Amount",
          filterable: !1,
          width: 180,
        },
        {
          field: "Actions",
          width: 100,
          title: this.selectedLang == "sp" ? "Acciones" : "Actions",
          sortable: !1,
          overflow: "visible",
          template: function (t) {
            var btn = "";
            if (!t.IsAdvancePayment) {
              if (
                PaymentMadeComponent.that.commonService.CheckHasRight(
                  "VIEW",
                  "PAYMENTMADE_DETAILS"
                )
              ) {
                btn += `<a id="${t.Id}" class="btnEdit m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details">
                                        <i class="la la-edit"></i>
                                        </a>`;
              }
              if (
                PaymentMadeComponent.that.commonService.CheckHasRight(
                  "DELETE",
                  "PAYMENTMADE_DETAILS"
                )
              ) {
                btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete">
                                        <i class="la la-trash"></i>
                                        </a>`;
              }
            } else {
              if (
                PaymentMadeComponent.that.commonService.CheckHasRight(
                  "VIEW",
                  "PAYMENTREQUEST_DETAILS"
                )
              ) {
                btn += `<a id="${t.Id}" class="btnEdit m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details">
                                        <i class="la la-edit"></i>
                                        </a>`;
              }
              if (
                PaymentMadeComponent.that.commonService.CheckHasRight(
                  "DELETE",
                  "PAYMENTREQUEST_DETAILS"
                )
              ) {
                btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete">
                                        <i class="la la-trash"></i>
                                        </a>`;
              }
            }

            return btn;
          },
        },
      ],
    });
    if (this.datatable) {
      // alert(4)
      $("#PaymentMadeDraft").css("border", "#2088d8 1px solid");
      this.datatable.search(this.selectedCard, "Status");
    }

    //added by vithujan 20-02-2023
    setTimeout(() => {
      var rows = PaymentMadeComponent.that.datatable;
      rows.rows(".m-datatable__row");
      PaymentMadeComponent.that.totalRowsCount = rows.nodes().length;
      PaymentMadeComponent.that.rowIndex = -1;
    }, 2000);
    //end
  }
  GetBillPaymentById(Id) {
    //added by maaria
    this.fromPaymentList = localStorage.getItem("fromPaymentList");
    //end
    this._appService.GetById("BillPayment", "GetBillPaymentById", Id).subscribe(
      (response) => {
        if (this.isFromAnotherPage == false) {
          this.router.navigate(["/PaymentMade", Id]);
        }
        this.PaymentData = response;
        this.PaymentId = this.PaymentData.Id;
        this.ShowAttachment = true;

        //add vithujan 06-07-2022
        this.isDelete = response.IsDelete;
        //end

        this.GetBankAccountDetailsByCompanyId();
        $("#PaymentMadeRemark").val(this.PaymentData.Remark);
        var Date1 = moment(this.PaymentData.PaymentDate, "YYYY-MM-DD");
        $("#PaymentDate").datepicker("setDate", new Date(Date1));
        if (this.PaymentData.ClearDate != null) {
          var Date1 = moment(this.PaymentData.ClearDate, "YYYY-MM-DD");
          $("#ClearDate").datepicker("setDate", new Date(Date1));
        }

        if (this.PaymentData.IsAdvancePayment) {
          this.paymentMode = "advancePayment";
        } else {
          this.paymentMode = "againstBill";
        }
        if (
          this.PaymentData.TDSId != null &&
          this.PaymentData.TDSId != undefined
        ) {
          let Id = this.PaymentData.TDSId + "__" + this.PaymentData.TDSRate;
          $("#TDSRates11").val(Id);
        }

        this.PaymentDetail = response.PaymentDetails;
        this.VendorDetail.Address = response.Address;
        this.VendorDetail.State = response.State;
        this.VendorDetail.City = response.City;
        this.VendorDetail.PostalCode = response.PostalCode;
        this.VendorDetail.Type = response.Type;

        setTimeout(() => {
          if (response.IsAuthorized == false) {
            $("#BtnBillPaymentSave").prop("disabled", false);
            $(".ClsAddBill").prop("disabled", false);
            // $("#BtnBillPaymentAuthorize").prop("disabled", false);
            $(".btnAuth").prop("disabled", false);
            // $("#BtnBillPaymentPost").prop("disabled", true);
            $(".btnPost").prop("disabled", true);
            $("#BtnPrint").prop("disabled", true);
            $("#BtnPrintDetail").prop("disabled", true);
            this.IsAuthorized = false;
            this.IsPosted = false;
          } else {
            $("#BtnBillPaymentSave").prop("disabled", true);
            $(".ClsAddBill").prop("disabled", true);
            //$("#BtnBillPaymentAuthorize").prop('disabled', true);
            $(".btnAuth").prop("disabled", true);
            if (response.IsPosted == true) {
              this.IsPosted = true;
              $(".btnPost").prop("disabled", true);
              //$("#BtnBillPaymentPost").prop('disabled', true);
              $("#BtnPrint").prop("disabled", false);
              $("#BtnPrintDetail").prop("disabled", false);
            } else {
              this.IsAuthorized = true;
              $(".btnPost").prop("disabled", false);
              //$("#BtnBillPaymentPost").prop('disabled', false);
              $("#BtnPrint").prop("disabled", true);
              $("#BtnPrintDetail").prop("disabled", true);
            }
          }
          //added by vithujan 23-02-2023
          setTimeout(() => {
            document.getElementById("SelectPaymentMadeVendor").focus();
          }, 100);
          //end
        }, 500);

        this.RefreshDropDown();
        setTimeout(() => {
          this.OnChangePaymentMode();
        }, 400);

        var Options =
          '<option value="' +
          this.PaymentData.VendorId +
          '">' +
          this.PaymentData.VendorName +
          "</option>";
        $("#SelectPaymentMadeVendor").html(Options);
        $("#SelectPaymentMadeVendor").val(this.PaymentData.VendorId).change();

        var Options1 =
          '<option value="' +
          this.PaymentData.PaidFromAccountId +
          '">' +
          this.PaymentData.PaidFromAccountName +
          "</option>";
        $("#SelectPaymentAccount").html(Options1);
        $("#SelectPaymentAccount")
          .val(this.PaymentData.PaidFromAccountId)
          .change();

        // var Options2 = '<option value="' + this.PaymentData.PaidToAccountId + '">' + this.PaymentData.PaidToAccountName + '</option>';
        // $("#SelectPaymentToAccount1").html(Options2);
        // $("#SelectPaymentToAccount1").val(this.PaymentData.PaidToAccountId).change();

        var Options =
          '<option value="' +
          this.PaymentData.THCId +
          '">' +
          this.PaymentData.THCName +
          "</option>";
        $("#SelectTHC").html(Options);
        $("#SelectTHC").val(this.PaymentData.THCId).change();

        this.CalculateNetAmounts(true);

        if (this.paymentMode == "againstBill") {
          if (this.commonService.CheckHasRight("EDIT", "PAYMENTMADE_DETAILS")) {
            $("#BtnBillPaymentSave").css("display", "inline-block");
            $("#BillNumber").prop("disabled", false);
          } else {
            $("#BtnBillPaymentSave").css("display", "none");
          }
        }
        if (this.paymentMode == "advancePayment") {
          if (
            this.commonService.CheckHasRight("EDIT", "PAYMENTREQUEST_DETAILS")
          ) {
            $("#BtnBillPaymentSave").css("display", "inline-block");
          } else {
            $("#BtnBillPaymentSave").css("display", "none");
          }
          $(".ClsAddBill").prop("disabled", true);
          $("#BillNumber").prop("disabled", true);
          $("#BtnAddBill").prop("disabled", true);
        }
      },
      (err) => {
        console.log(err);
        this.toastr.error("Error occurred while fetching Data !", "error");
      }
    );
  }
  DeleteBillPaymentById(Id, From) {
    this._appService
      .Delete("BillPayment", "DeleteBillPaymentById", Id)
      .subscribe(
        (response) => {
          //added by vithujan 19-10-2023 - Siddarth
          this.SaveDeletedTransactionHistory(Id);

          if (From == "Detail") {
            this.OnGoBack();
          } else {
            this.ClearDashboardData();
            this.datatable.destroy();
            this.GetBillPaymentList();
          }

          this.toastr.success("Successfully Deleted !", "Success");
        },
        (err) => {
          this.toastr.error("An error occured while deleting data !", "error");
        }
      );
  }
  
  //-----------------------------Save--------------------------------
  SavePaymentReceipt() {

    // Helpers.setLoading(true);
    this.isDisabled=true;
    $("#BtnBillPaymentSave").prop("disabled", true);
    var flag = this.ValidateRequiredField();
    if (flag != false) {
      // if (this.PaymentData.Amount > 0) {
      if (this.paymentMode == "advancePayment")
        this.PaymentData.IsAdvancePayment = true;
      else this.PaymentData.IsAdvancePayment = false;

      if (
        $("#TDSRates11").val() != null &&
        $("#TDSRates11").val() != undefined &&
        $("#TDSRates11").val() != "" &&
        $("#TDSRates11").val() != "NA"
      ) {
        this.PaymentData.TDSId = $("#TDSRates11").val().split("__")[0];
      }
      if (this.PaymentData.TDSId == "NA") {
        this.PaymentData.TDSId == null;
      }

      this.PaymentData.NetTotal = this.PaymentData.NetTotal == undefined || this.PaymentData.NetTotal == '' || this.PaymentData.NetTotal == null ? 0 : this.PaymentData.NetTotal;
      this.PaymentData.NetTotal = parseFloat(
        this.PaymentData.NetTotal.toFixed(2)
      );
      if (
        this.PaymentDetail.length != 0 ||
        this.paymentMode == "advancePayment"
      ) {
        Helpers.setLoading(true);
        this.PaymentData.PaymentDetail = [];
        this.PaymentData.PaymentDetail = this.PaymentDetail;
        this.PaymentData.CompanyId = this.CompanyId;
        this.PaymentData.THCId = $("#SelectTHC").val();
        this.PaymentData.PaymentDate = this.GetFormattedDate(
          "PaymentDate",
          this.PaymentData.PaymentDate
        );
        this.PaymentData.Remark = $("#PaymentMadeRemark").val();
        this.PaymentData.BankStatementId = this.BankStatementId;
        this.PaymentData.userId = this.userId;
        this._appService
          .Post("BillPayment", "SaveBillPayment", this.PaymentData)
          .subscribe(
            (response) => {
              this.PaymentId = response.Id;
              this.PaymentData.Id = response.Id;
              this.ShowAttachment = true;
              // $("#BtnBillPaymentAuthorize").prop("disabled", false);
              this.isDisabled = false;
              $("#BtnBillPaymentSave").prop("disabled", false);
              $(".btnAuth").prop("disabled", false);
              $("#BtnPrint").prop("disabled", true);
              $("#BtnPrintDetail").prop("disabled", true);
              const Saved = this.translate.instant("ALERTMESSAGES.Saved");
              this.toastr.success(Saved, "Success");
              this.GetBillPaymentById(this.PaymentId);
              Helpers.setLoading(false);
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error(err._body.replace(/"/g, ""), "error");
            }
          );
      } else {
        this.toastr.error("Please Add Bill For Payment", "error");
      }
      // }
      // else {
      //   this.toastr.error("Amount Paid should be greater than zero! ", "Error");
      // }
    } else {
      this.toastr.error("Please Insert Required Fields !", "error");
      this.isDisabled = false;
      $("#BtnBillPaymentSave").prop("disabled", false);
    }
    //Helpers.setLoading(false);
  }

  DeleteBillFromList(index) {
    swal({
      title: "Are you sure?",
      type: "warning",
      showCancelButton: !0,
      confirmButtonText: "Yes, delete it!",
    }).then(function (e) {
      if (
        PaymentMadeComponent.that.PaymentDetail[index].BillPaymentId !==
        undefined
      ) {
        PaymentMadeComponent.that._appService
          .GetByFourId(
            "BillPayment",
            "DeleteBillFromList",
            PaymentMadeComponent.that.PaymentDetail[index].Id,
            PaymentMadeComponent.that.PaymentDetail[index].BillPaymentId,
            PaymentMadeComponent.that.PaymentDetail[index].BillId,
            PaymentMadeComponent.that.userId
          )
          .subscribe(
            (response) => {
              if (response[0].resultStatus === "OK") {
                PaymentMadeComponent.that.toastr.success(
                  "Deleted Successfully !",
                  "Success"
                );
                PaymentMadeComponent.that.PaymentDetail.splice(index, 1);
                PaymentMadeComponent.that.CalculateNetAmounts(true);
              } else {
                PaymentMadeComponent.that.toastr.error(
                  response[0].resultStatus,
                  "error"
                );
              }
            },
            (err) => {
              PaymentMadeComponent.that.toastr.error(
                "Error occurred while delete data !",
                "error"
              );
            }
          );
      } else {
        PaymentMadeComponent.that.PaymentDetail.splice(index, 1);
        PaymentMadeComponent.that.CalculateNetAmounts(true);
      }
    });
  }
  //-------------------------Authorize------------------------
  AuthorizeBillPayment() {
    Helpers.setLoading(true);
    this._appService
      .GetByThreeId(
        "Common",
        "AuthorizeTransaction",
        5,
        this.PaymentId,
        this.CompanyId
      )
      .subscribe(
        (response) => {
          $("#BtnBillPaymentSave").prop("disabled", true);
          $(".ClsAddBill").prop("disabled", true);
          // $("#BtnBillPaymentAuthorize").prop("disabled", true);
          $(".btnAuth").prop("disabled", true);
          // $("#BtnBillPaymentPost").prop("disabled", false);
          $(".btnPost").prop("disabled", false);
          $("#BtnPrint").prop("disabled", true);
          $("#BtnPrintDetail").prop("disabled", true);
          $(".btnAuth").prop("disabled", true);
          this.IsAuthorized = true;
          this.IsPosted = false;
          if (response == 8) {
            this.toastr.error("Please Map TDS before posting");
            $(".btnAuth").prop("disabled", false);
            $("#BtnBillPaymentSave").prop("disabled", false);
            $(".btnPost").prop("disabled", true);
            return;
          }

          this.toastr.success("Bill Authorized Successfully !", "Success");

        },
        (err) => {
          // this.toastr.error("An error occured  !", "error");
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
    Helpers.setLoading(false);
  }
  //-------------------------Posting to Accounts-------------------------
  PostBillPayment() {
    var Mode = $("#BillsPaymentMode option:selected").text().trim();
    if (this.ICICIBankPaymentAllowed == true && Mode == 'Bank Transfer' && this.PaymentData &&
      this.PaymentData.PaidFromAccountName &&
      this.PaymentData.PaidFromAccountName.toLowerCase().includes('icici')
    ) {
      this.GenerateOTP();
    } else {
      this.PostPayment();
    }
  }

  PostPayment() {
    Helpers.setLoading(true);
    this._appService
      .GetByTwoId(
        "BillPayment",
        "PostBillPayment",
        this.PaymentId,
        this.CompanyId
      )
      .subscribe(
        (response) => {
          if (response != 1000) {
            $("#BtnBillPaymentPost").prop("disabled", true);
            // $(".btnPost").prop('disabled', true);
            $("#BtnPrint").prop("disabled", false);
            $("#BtnPrintDetail").prop("disabled", false);
            $(".btnPost").prop("disabled", true);
            this.IsAuthorized = false;
            this.IsPosted = true;
            this.GetJVSummaryData();
            this.toastr.success(
              "Bill Payment Posted Successfully !",
              "Success"
            );
          } else {
            this.toastr.error(
              "Zero amount payment is not allowed to post !",
              "Error"
            );
          }
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
    Helpers.setLoading(false);
  }

  //----------------------------------------------------------------------
  BillPaymentMode: any;
  OnChangePaymentMode() {
    $("#SelectPaymentAccount").prop("disabled", false);
    var Mode = $("#BillsPaymentMode option:selected").text().trim();

    this.BillPaymentMode = '';
    this.BillPaymentMode = Mode;

    if (
      Mode == "Bank Remittance" ||
      Mode == "Bank Transfer" ||
      Mode == "Cheque"
    ) {
      this.PaymentData.PaymentType = 1;
      $("#Pettycashlink").css("display", "none");
    }
    if (Mode == "Cash") {
      this.PaymentData.PaymentType = 3;
      // this.CheckForPattyCase();
    }
    if (Mode == "Credit Card") {
      this.PaymentData.PaymentType = 2;
      $("#Pettycashlink").css("display", "none");
    }
    if (Mode == "Toll Card") {
      this.PaymentData.PaymentType = 4;
      $("#Pettycashlink").css("display", "none");
    }
    if (Mode == "Fuel Card") {
      this.PaymentData.PaymentType = 5;
      $("#Pettycashlink").css("display", "none");
    }
    if (Mode == "Debtors or Customers") {
      this.PaymentData.PaymentType = 6;
      $("#Pettycashlink").css("display", "none");
    }
  }

  CheckForPattyCase() {
    this.GetCountForPettyCash = 0;
    this._appService
      .GetById("BillPayment", "CheckForPattyCase", this.CompanyId)
      .subscribe(
        (response) => {
          this.GetCountForPettyCash = response;
          if (this.GetCountForPettyCash == 0) {
            $("#Pettycashlink").css("display", "block");
            swal({
              title: "Petty Cash Account!",
              text: "Petty cash account not available for this branch please create first it.",
              type: "warning",
              showCancelButton: !1,
              confirmButtonText: "OK",
            }).then(function (e) {
              if (e.value == true) {
                return false;
              }
            });
          }
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }
  CreateNewPettyCashAcc() {
    $("#ModalForPettyCash").modal("show");
  }
  SaveAccountData() {
    if (
      !this.commonService.ValidateRequiredField(
        $("#Name"),
        "Please Enter Account Name",
        "after",
        ""
      )
    ) {
      return false;
    }
    this.AccountData.Name = $("#Name").val();
    this.AccountData.ParentId = "5C3379BD-6DE6-E911-944F-BC5FF49E6744";
    this.AccountData.CompanyId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).Id;
    this.AccountData.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    this.AccountData.Type = 3;
    this.AccountData.AccountType = 2;
    this.AccountData.IsActive = true;
    // this.AccountData.IsDelete = false;

    this._appService
      .Post("ChartsofAccount", "SaveAccount", this.AccountData)
      .subscribe(
        (response) => {
          $("#ModalForPettyCash").modal("hide");
          setTimeout(() => {
            (<any>$(".PaymentAccount")).selectpicker("refresh");
          }, 100);
          this.toastr.success("Data saved Successfully !", "Success");
        },
        (err) => {
          this.toastr.error("Error occurred while saving data !", "error");
        }
      );
  }
  OnAddBill() {
    var FlagExists = this.CheckIfBillAlreadyExists();
    if (FlagExists != true) {
      var flag = this.ValidateBillNumber();
      if (flag != false) {
        this._appService.GetByThreeId("BillPayment", "GetBill", $("#BillNumber").val().trim(), this.PaymentData.VendorId, this.CompanyId).subscribe((response) => {
          var billObj: any = [];
          billObj = response;
          if (billObj.length > 0) {
            this.PaymentDetail.push(billObj[0]);
            $("#BillNumber").val("");
            this.CalculateNetAmounts(true);
          } else {
            this.toastr.error("Bill not Found !", "error");
          }
        },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "error");
          }
        );
      } else {
        this.toastr.error("Please Insert Bill Number !", "error");
      }
    } else {
      $("#InvoiceNumber").val("");
      this.toastr.error("This Bill Already Exists For this Payment !", "error");
    }
  }
  CalculateNetAmounts(IsCalculateRoundoff) {

    this.PaymentData.NetTotal = 0;
    this.PaymentData.TotalTDS = 0;
    this.PaymentData.AmountBalance = 0;
    this.PaymentData.TDSBalance = 0;
    this.PaymentDetail.forEach((element) => {
      element.PaidAmount =
        element.PaidAmount == undefined ? 0 : element.PaidAmount;
      element.TDSAmount =
        element.TDSAmount == undefined ? 0 : element.TDSAmount;
      this.PaymentData.NetTotal += parseFloat(element.PaidAmount);
      this.PaymentData.TotalTDS += parseFloat(element.TDSAmount);
    });
    this.PaymentData.AmountBalance =
      this.PaymentData.Amount - this.PaymentData.NetTotal;
    this.PaymentData.TDSBalance =
      this.PaymentData.TDSAmount - this.PaymentData.TotalTDS;
    if (IsCalculateRoundoff) this.CalculateRoundOff(false);
  }
  CheckIfBillAlreadyExists() {
    var FlagExists = false;
    this.PaymentDetail.forEach((element) => {
      if (element.BillNumber == $("#BillNumber").val().trim()) {
        FlagExists = true;
      }
    });
    return FlagExists;
  }

  CalculateRoundOff(IsCalculateTDS) {
    if (IsCalculateTDS) {
      if (
        $("#TDSRates11").val() != null &&
        $("#TDSRates11").val() != "NA" &&
        this.paymentMode !== "againstBill"
      ) {
        var TDSRate = parseFloat($("#TDSRates11").val().split("__")[1]);
        if (TDSRate != 0 && TDSRate != null && TDSRate != undefined) {
          var Deduction: any =
            parseFloat((this.PaymentData.ExpectedBillAmount * (TDSRate / 100)).toFixed(2));
          this.PaymentData.TDSAmount = parseFloat(Deduction.toFixed(2));
          $("#PreviousTDSApplied").val(this.PaymentData.TDSAmount);
          this.PaymentData.Amount =
            parseFloat((this.PaymentData.Amount - this.PaymentData.TDSAmount).toFixed(2));
        } else {
          this.PaymentData.TDSAmount = 0;
          $("#PreviousTDSApplied").val(this.PaymentData.TDSAmount);
        }
      } else {
        this.PaymentData.TDSAmount = 0;
        $("#PreviousTDSApplied").val(this.PaymentData.TDSAmount);
      }
      this.CalculateNetAmounts(false);
    }
    this.PaymentData.RoundOffAmount = 0;
    this.PaymentData.RoundOffAmount =
      this.PaymentData.NetTotal - this.PaymentData.Amount;
  }

  OnManualTDSChange() {
    var PreviosTDSApplied = $("#PreviousTDSApplied").val();
    this.PaymentData.Amount =
      this.PaymentData.Amount +
      parseFloat(parseFloat(PreviosTDSApplied).toFixed(2));
    $("#PreviousTDSApplied").val(this.PaymentData.TDSAmount);
    this.PaymentData.Amount =
      this.PaymentData.Amount - this.PaymentData.TDSAmount;
  }

  ValidateBillNumber() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField(
        $("#BillNumber"),
        "Please Enter Number",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField2(
        $("#SelectPaymentMadeVendor"),
        $("#FieldsetNewCharge"),
        "Please Select Vendor / Driver",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    return flag;
  }
  ValidateRequiredField() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField(
        $("#PaymentDate"),
        "Please Insert Payment Date",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#PaymentAmount"),
        "Please Insert Payment Amount",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    if (
      !this.commonService.ValidateRequiredField2(
        $("#BillsPaymentMode"),
        $("#FieldSetPaymentModeType"),
        "Please Select Payment Mode",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField2(
        $("#SelectPaymentAccount"),
        $("#FieldsetPaymentAccount"),
        "Please Select Paid Account",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField2(
        $("#SelectPaymentMadeVendor"),
        $("#FieldsetNewCharge"),
        "Please Select Vendor / Driver",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    //added by vithu 17-11-2025 - Siddarth
    if (this.ICICIBankPaymentAllowed == true && this.BillPaymentMode == 'Bank Transfer' && this.PaymentData &&
      this.PaymentData.PaidFromAccountName &&
      this.PaymentData.PaidFromAccountName.toLowerCase().includes('icici')
    ) {
      if (
        !this.commonService.ValidateRequiredField2(
          $("#TransactionType"),
          $("#FieldSetTransactionType"),
          "Please Select Transaction Type",
          "after",
          ""
        )
      ) {
        flag = false;
      }
    }
    return flag;
  }
  ClearValidation() {
    this.commonService.ClearMessage($("#BillNumber"));
    this.commonService.ClearMessage($("#PaymentDate"));
    this.commonService.ClearMessage($("#PaymentAmount"));
    this.commonService.ClearMessage($("#BillsPaymentMode"));
    this.commonService.ClearMessage($("#FieldSetPaymentModeType"));
    this.commonService.ClearMessage($("#SelectPaymentAccount"));
    this.commonService.ClearMessage($("#FieldsetPaymentAccount"));
    this.commonService.ClearMessage($("#SelectPaymentMadeVendor"));
    this.commonService.ClearMessage($("#FieldsetNewCharge"));
  }

  GetPrintData(PaymentId) {
    Helpers.setLoading(true);
    this._appService
      .GetByTwoId(
        "BillPayment",
        "GetPrintData",
        PaymentId,
        PaymentMadeComponent.that.PaymentData.VendorId
      )
      .subscribe((response) => {
        this.PrintPaymentHeaderObj = response.BillPaymentPrintViewMode;
        this.PrintPaymentDetails = response.BillPaymentDetailPrintViewModel;
        this.PrintTHCArray = this.PrintPaymentDetails.THCNumber;

        // this.PrintPaymentDetails.forEach(element => {
        //     this.PrintTHCArray = element.THCNumber;
        // });
        //add kevin for change in summery print 06/04/2020
        // if (Array.isArray(this.PrintTHCArray)) {
        //     this.PrintTHC = '';
        // }
        // else {
        //     this.PrintTHC = this.PrintTHCArray.join(',');
        // }
        this.PrintTHC = this.PaymentData.THCName;

        this.SubTotalBillAmount = 0;
        this.SubTotalPaidAmount = 0;
        this.SubTotalAmountDue = 0;
        this.SubTotalPaymentAmount = 0;
        this.SubTotalTDS = 0;
        for (let index = 0; index < this.PrintPaymentDetails.length; index++) {
          this.SubTotalBillAmount =
            this.PrintPaymentDetails[index].BillAmount +
            this.SubTotalBillAmount;
          this.SubTotalPaidAmount =
            this.PrintPaymentDetails[index].PaidAmount +
            this.SubTotalPaidAmount;
          this.SubTotalAmountDue =
            this.PrintPaymentDetails[index].AmountDue + this.SubTotalAmountDue;
          this.SubTotalPaymentAmount =
            this.PrintPaymentDetails[index].Payment +
            this.SubTotalPaymentAmount;
          this.SubTotalTDS =
            this.PrintPaymentDetails[index].TDS +
            this.SubTotalTDS;
        }

        this.SubTotalBillAmount = parseFloat(
          this.SubTotalBillAmount.toFixed(2)
        );
        this.SubTotalPaidAmount = parseFloat(
          this.SubTotalPaidAmount.toFixed(2)
        );
        this.SubTotalAmountDue = parseFloat(this.SubTotalAmountDue.toFixed(2));
        this.SubTotalPaymentAmount = parseFloat(
          this.SubTotalPaymentAmount.toFixed(2)
        );

        setTimeout(() => {
          var divElements = document.getElementById("PrintSummary");
          var $iframe = $("<iframe id='frame'>").appendTo("body");
          var printDiv = divElements.innerHTML;
          var win = $iframe[0].contentWindow || $iframe[0];
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 500);
            });
          });
          Helpers.setLoading(false);
          $iframe.contents().find("body").html(printDiv);
        }, 1000);
      });
  }

  OnSelectBill() {
    var FlagExists = this.CheckIfBillAlreadyExists();
    if (FlagExists != true) {
      var flag = this.ValidateBillNumberForMultipleSelection();
      if (flag != false) {
        $("#PendingBillModal").modal("show");
        setTimeout(() => {
          this.GetPendingBills();
        }, 500);
      } else {
        this.toastr.error("Please Insert Bill Number !", "error");
      }
    } else {
      this.toastr.error("This Bill Already Exists For this Payment !", "error");
    }
  }

  GetPendingBills() {

    this.datatableForPendingBill = (<any>$("#tblPendingBillList")).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/BillPayment/GetPendingBillList",
            headers: {
              "Authorization": PaymentMadeComponent.that._appService.getAuthToken(),
            },
            params: {
              // custom parameters
              CompanyId: PaymentMadeComponent.that.CompanyId,
              VendorOrDriverId: PaymentMadeComponent.that.PaymentData.VendorId,
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      search: {
        onChange: true,
        input: $("#SearchValue"),
        delay: 400,
      },
      rows: {},
      columns: [
        {
          field: "BillId",
          title: "#",
          sortable: !1,
          width: 20,
          selector: {
            class:
              "m-checkbox m-datatable--on-check m-checkbox--solid m-checkbox--brand BookingIdCheckbox",
          },
          template: function (t) {
            let value = t;
            return value;
          },
        },
        {
          field: "BillNumber",
          title: "BillNumber",
          sortable: false,
          width: 180,
        },
        {
          field: "BillAmount",
          title: "Bill Amount",
          sortable: false,
          width: 100,
        },
        {
          field: "AmountDue",
          title: "Pending Amount",
          sortable: false,
          width: 100,
        },
        {
          field: "ReferenceNo",
          title: "Reference No",
          sortable: false,
          width: 180,
        },
        {
          field: "ReferenceDate",
          title: "Reference Date",
          sortable: false,
          width: 180,
        },
      ],
    });
  }

  SelectBills() {
    this.PendingBillList = [];
    var rows = this.datatableForPendingBill;
    rows.rows(".m-datatable__row--active");
    if (rows.nodes().length > 0) {
      $.each(rows.nodes(), function (i) {
        var keys = Object.keys(rows.nodes()[i]);
        var PendingBillDetail: any = {};
        PendingBillDetail = rows.nodes()[i][keys[0]].obj;

        var FlagExistsBillNumber =
          PaymentMadeComponent.that.CheckIfBillAlreadyExistsFromSelectMultiple(
            PendingBillDetail.BillNumber
          );
        if (!FlagExistsBillNumber) {
          PaymentMadeComponent.that.PaymentDetail.push(PendingBillDetail);
          PaymentMadeComponent.that.CalculateNetAmounts(true);
        }
      });
      $("#PendingBillModal").modal("hide");
      PaymentMadeComponent.that.datatableForPendingBill.destroy();
    } else {
      this.toastr.error("Please Select any Trip !", "Alert");
    }
  }

  ValidateBillNumberForMultipleSelection() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField2(
        $("#SelectPaymentMadeVendor"),
        $("#FieldsetNewCharge"),
        "Please Select Vendor / Driver",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    return flag;
  }

  CheckIfBillAlreadyExistsFromSelectMultiple(BillNumber) {
    var FlagExists = false;
    this.PaymentDetail.forEach((element) => {
      if (element.BillNumber == BillNumber) {
        FlagExists = true;
      }
    });
    return FlagExists;
  }
  ClosePendingBillsList() {
    $("#PendingBillModal").modal("hide");
    PaymentMadeComponent.that.datatableForPendingBill.destroy();
  }

  DownloadPaymentAdvice() {
    $("#ModalDownloadPaymentAdvice").modal("show");
    this.RefreshvalidDate();
    this.GetSelectDataForbank();
    this.OnDownloadClearClick();
  }

  GetSelectDataForbank() {
    $("#AccountsForBankReconcile1").select2({
      tags: true, //add maari
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/BankReconcile/GetAccountListForBankReconcile",
        headers: {
          "Authorization": PaymentMadeComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            CompanyId: PaymentMadeComponent.that.CompanyId,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          params.CompanyId = PaymentMadeComponent.that.CompanyId;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],

      placeholder: "Enter Bank Name",
    });

    //add by maaria on 23-10-2023
    $("#AccountsForBankReconcile1").on("select2:select", function (e) {
      var data = e.params.data;
    });
    //end
  }

  OnDownloadPaymentAdvice() {
    var flag = this.ValidateDownlaodRequiredField();
    if (flag != false) {
      Helpers.setLoading(true);
      if (
        $("#FromDateForAdvice").val() != "" &&
        $("#FromDateForAdvice").val() != undefined
      )
        this.DownloadFromDate = this.GetFormattedDate(
          "FromDateForAdvice",
          this.DownloadFromDate
        );
      if (
        $("#ToDateForAdvice").val() != "" &&
        $("#ToDateForAdvice").val() != undefined
      )
        this.DownloadToDate = this.GetFormattedDate(
          "ToDateForAdvice",
          this.DownloadToDate
        );
      this._appService
        .GetByFiveId(
          "BillPayment",
          "GetPaymentAdviceDownloadData",
          this.CompanyId,
          $("#AccountsForBankReconcile1").val(),
          this.DownloadFromDate,
          this.DownloadToDate,
          $("#AdviceCode").val()
        )
        .subscribe(
          (response) => {
            this.DownloadFile(response);
            Helpers.setLoading(false);
            $("#ModalDownloadPaymentAdvice").modal("hide");
          },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
    }
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }

    var blob = this.commonService.b64toBlob(
      FileContent.Content,
      FileContent.ContentType
    );
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadPaymentAdvice").attr("href", url);
    $("#DownLoadPaymentAdvice").attr("download", FileContent.FileName);
    let element: HTMLElement = document.getElementById(
      "DownLoadPaymentAdvice"
    ) as HTMLElement;
    element.attributes;
    element.click();
    Helpers.setLoading(false);
  }

  OnDownloadClearClick() {
    this.DownloadFromDate = "";
    this.DownloadToDate = "";
    $("#FromDateForAdvice").val("");
    $("#ToDateForAdvice").val("");
    $("#AdviceCode").val("");
    $(".AccountsForBankReconcile").val("");
    $(".AccountsForBankReconcile").select2("destroy");
    this.GetSelectDataForbank();
  }

  ValidateDownlaodRequiredField() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField2(
        $("#AccountsForBankReconcile1"),
        $("#FieldsetBankAccount"),
        "Please Select Bank",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#AdviceCode"),
        "Please Insert Code",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    return flag;
  }
  ClearDownloadValidation() {
    this.commonService.ClearMessage($("#AccountsForBankReconcile1"));
    this.commonService.ClearMessage($("#AdviceCode"));
  }

  OnShowJVDetail() {
    if ($("#btnShowPaymentJVDetails")[0].classList.value == "fa fa-plus") {
      $("#btnShowPaymentJVDetails").removeClass("fa-plus");
      $("#btnShowPaymentJVDetails").addClass("fa-minus");
      $("#ShowJVPaymentDetails").slideToggle();
      this.GetJVSummaryData();
    } else {
      $("#btnShowPaymentJVDetails").addClass("fa-plus");
      $("#btnShowPaymentJVDetails").removeClass("fa-minus");
      $("#ShowJVPaymentDetails").slideToggle();
      this.JVSummaryData = [];
    }
  }

  GetJVSummaryData() {
    if (this.PaymentData.Id != null && this.PaymentData.Id != undefined) {
      Helpers.setLoading(true);
      this._appService
        .GetById("Sales", "GetJournalEntrySummary", this.PaymentData.Id)
        .subscribe(
          (response) => {
            this.JVSummaryData = response;
          },
          (err) => {
            this.toastr.error("An error occured  !", "error");
          }
        );
      Helpers.setLoading(false);
    }
  }

  OnChangeTDS() {
    if (
      this.PaymentData.TDSAmount != undefined &&
      this.PaymentData.TDSAmount != null
    )
      //console.log("tds amount jo add hoga", this.PaymentData.TDSAmount.toFixed(2))
      this.PaymentData.Amount =
        this.PaymentData.Amount +
        parseFloat(this.PaymentData.TDSAmount.toFixed(2));
    //console.log("before if wala amount", this.PaymentData.Amount)
    if ($("#TDSRates11").val() != null && $("#TDSRates11").val() != "NA") {
      var TDSRate = parseFloat($("#TDSRates11").val().split("__")[1]);
      if (TDSRate != 0 && TDSRate != null && TDSRate != undefined) {
        var Deduction: any =
          this.PaymentData.ExpectedBillAmount * (TDSRate / 100);
        this.PaymentData.TDSAmount = parseFloat(Deduction.toFixed(2));
        $("#PreviousTDSApplied").val(this.PaymentData.TDSAmount);
        this.PaymentData.Amount =
          this.PaymentData.Amount - this.PaymentData.TDSAmount;
        //console.log("inner if wala amount", this.PaymentData.Amount)
      } else {
        this.PaymentData.TDSAmount = 0;
        $("#PreviousTDSApplied").val(this.PaymentData.TDSAmount);
      }
    } else {
      this.PaymentData.TDSAmount = 0;
      $("#PreviousTDSApplied").val(this.PaymentData.TDSAmount);
    }
    // console.log("bind wala advance", this.PaymentData.Amount);

    this.CalculateNetAmounts(true);
  }

  //--------------------Event Receive-----------------
  ReceiveAdvancePaymentData(data: any) {
    // this.OnGoBack();
    //    if (data.TDSId != '') {

    //  }

    this.OnNewPayment("advancePayment");
    this.PaymentData = data;
    this.PaymentData.Amount = data.PendingAdvanceAmount;
    // this.PaymentData.TDSAmount = 0;
    var Options =
      '<option value="' +
      this.PaymentData.VendorId +
      '">' +
      this.PaymentData.VendorName +
      "</option>";
    $("#SelectPaymentMadeVendor").html(Options);
    $("#SelectPaymentMadeVendor").val(this.PaymentData.VendorId).change();

    var Options =
      '<option value="' +
      this.PaymentData.THCId +
      '">' +
      this.PaymentData.THC +
      "</option>";
    $("#SelectTHC").html(Options);
    $("#SelectTHC").val(this.PaymentData.THCId).change();

    this.VendorDetail = {};
    this.VendorDetail.Address = data.Address;
    this.VendorDetail.State = data.State;
    this.VendorDetail.City = data.City;
    this.VendorDetail.Country = data.Country;
    this.VendorDetail.PostalCode = data.PostalCode;
    this.VendorDetail.GSTNo = data.GSTNo;
    this.VendorDetail.Type = data.Type;
    $("#SelectPaymentToAccount1").prop("disabled", false);

    this.PaymentData.VendorId = data.VendorId;
    this.PaymentData.PANNo = data.PANNumber;
    this.PaymentData.VehicleNo = data.VehicleNo;
    this.PaymentData.VehicleSize = data.VehicleSize;
    this.PaymentData.PaidWeight = data.PaidWeight;
    this.GetBankAccountDetailsByCompanyId();
    $("#SelectPaymentToAccount1").prop("disabled", false);
    if (data.TDSId != "") {
      $("#TDSRates11").val(data.TDSId);
      var TDSRate = parseFloat($("#TDSRates11").val().split("__")[1]);
      this.PaymentData.TDSAmount = TDSRate;
      this.RefreshDropDown();
      this.OnChangeTDS();
    }
  }

  //Attachment
  OnAttachmentClick() {
    $("#DocumentFrom").val("BillPayment");
    this.AttachmentChild.DocumentType = "BillPayment";
    this.AttachmentChild.DocumentTransaction = this.PaymentData.Id;
    this.AttachmentChild.IsSearchHidden = true;
    this.AttachmentChild.GetDocumentsList();
    setTimeout(() => {
      if (this.AttachmentChild.datatable) {
        this.AttachmentChild.datatable.search(
          this.AttachmentChild.DocumentTransaction,
          "ReferenceId"
        );
      }
    }, 300);
  }

  //add kevin 25/03/2020
  fullPay() {
    this.payFull = !this.payFull;
    if (this.payFull == true) {
      for (var i = 0; i < this.PaymentDetail.length; i++) {
        this.PaymentDetail[i].PaidAmount = this.PaymentDetail[i].AmountDue;
        this.CalculateNetAmounts(true);
      }
    } else {
      for (var i = 0; i < this.PaymentDetail.length; i++) {
        this.PaymentDetail[i].PaidAmount = 0;
        this.CalculateNetAmounts(true);
      }
    }
  }

  //Add kevin 08/04/2020
  GetPrintDetailData(PaymentId) {
    Helpers.setLoading(true);
    this._appService
      .GetByTwoId(
        "BillPayment",
        "GetPrintDetailData",
        PaymentId,
        PaymentMadeComponent.that.PaymentData.VendorId
      )
      .subscribe((response) => {
        this.PrintDetailPaymentHeaderObj =
          response.BillPaymentDetailPrintViewMode;
        this.PrinDetailPaymentDetails =
          response.BillPaymentDetailDetailPrintViewModel;
        this.PrintTHCArray = this.PrintPaymentDetails.THCNumber;
        this.PrintTHC = this.PaymentData.THCName;

        console.log('ff', this.PrinDetailPaymentDetails);

        // this.SubTotalBillAmount = 0;
        // this.SubTotalPaidAmount = 0;
        // this.SubTotalAmountDue = 0;
        // this.SubTotalPaymentAmount = 0;

        // for (let index = 0; index < this.PrintPaymentDetails.length; index++) {
        //     this.SubTotalBillAmount = this.PrintPaymentDetails[index].BillAmount + this.SubTotalBillAmount;
        //     this.SubTotalPaidAmount = this.PrintPaymentDetails[index].PaidAmount + this.SubTotalPaidAmount;
        //     this.SubTotalAmountDue = this.PrintPaymentDetails[index].AmountDue + this.SubTotalAmountDue;
        //     this.SubTotalPaymentAmount = this.PrintPaymentDetails[index].Payment + this.SubTotalPaymentAmount;
        // }

        // this.SubTotalBillAmount = parseFloat(this.SubTotalBillAmount.toFixed(2));
        // this.SubTotalPaidAmount = parseFloat(this.SubTotalPaidAmount.toFixed(2));
        // this.SubTotalAmountDue = parseFloat(this.SubTotalAmountDue.toFixed(2));
        // this.SubTotalPaymentAmount = parseFloat(this.SubTotalPaymentAmount.toFixed(2));

        setTimeout(() => {
          var divElements = document.getElementById("PrintDetail");
          var $iframe = $("<iframe id='frame'>").appendTo("body");
          var printDiv = divElements.innerHTML;
          var win = $iframe[0].contentWindow || $iframe[0];
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 500);
            });
          });
          Helpers.setLoading(false);
          $iframe.contents().find("body").html(printDiv);
        }, 1000);
      });
  }

  ShowAuditTrail_bp() {
    if ($("#btnShowAuditTrail_bp")[0].classList.value == "fa fa-plus") {
      $("#btnShowAuditTrail_bp").removeClass("fa-plus");
      $("#btnShowAuditTrail_bp").addClass("fa-minus");
      $("#ShowAuditTrail_bp").slideToggle();
    } else {
      $("#btnShowAuditTrail_bp").addClass("fa-plus");
      $("#btnShowAuditTrail_bp").removeClass("fa-minus");
      $("#ShowAuditTrail_bp").slideToggle();
    }
    var Id = this.PaymentData.Id;
    var pageURL = "PaymentMade";
    if (this.PaymentData.Id != null && this.PaymentData.Id != undefined) {
      this._appService
        .GetByTwoId("Common", "getAuditTrailData", Id, pageURL)
        .subscribe(
          (response) => {
            this.AuditTrailData = response;
          },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
    }
  }

  //add vithujan 04-07-2022
  DeletePaymentsPermanentlyById(Id) {
    this._appService
      .GetById("BillPayment", "DeletePaymentsPermanentlyById", Id)
      .subscribe(
        (response) => {
          if (response[0].isDone == "OK") {
            this.toastr.success("Successfully Deleted !", "Success");
          } else {
            this.toastr.error(
              "An error occured while deleting data !",
              "error"
            );
          }
        },
        (err) => {
          console.log(err);
          this.toastr.error("An error occured while deleting data !", "error");
        }
      );
  }
  //end

  //added by vithujan 09-01-2023
  disableContextMenu() {
    this.contextmenu = false;
  }

  onrightClick(event) {
    this.contextmenuX = event.clientX;
    this.contextmenuY = event.clientY;
    this.contextmenu = true;
  }

  redirectPage(name: any) {
    if (name == "PendingBills") this.router.navigate(["/PendingBills"]);
    if (name == "Bills") this.router.navigate(["/Bills"]);
    if (name == "PaymentRequest") this.router.navigate(["/PaymentRequest"]);
    if (name == "Expenses") this.router.navigate(["/Expense"]);
    if (name == "SchedulePayment") this.router.navigate(["/SchedulePayment"]);
  }
  //end

  //added by vithujan 25-01-2023
  showAdvanceSearch() {
    $("#SalesInvoiceAdvanceSearch").modal("show");
    setTimeout(function () {
      (<any>$("#id_ddlFinancialyear")).selectpicker("refresh");
    }, 100);
  }

  GetPaymentNoByCompany() {
    $("#SelectBillList").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/BillPayment/GetPaymentNoByCompany",
        headers: {
          "Authorization": PaymentMadeComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: PaymentMadeComponent.that.CompanyId,
            param1: params.term,
          };
        },
        processResults: function (data, params) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Enter Payment No",
    });
  }

  GetCustomerVendorSelect2Data() {
    $("#CompanyData").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetVendorName",
        headers: {
          "Authorization": PaymentMadeComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            TenantId: PaymentMadeComponent.that.TenantId,
            Type: "Bills",
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Enter Vendor Name",
    });
  }

  RefreshvalidDateModal() {
    setTimeout(() => {
      $(".datepicker3").datepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "dd-M-yyyy",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
    }, 200);
  }

  GetAccountingYear() {
    this._appService.Get("Common", "GetAccountingYear").subscribe(
      (response) => {
        this.FinancialYearArray = response;

        setTimeout(() => {
          (<any>$("#id_ddlFinancialyear")).selectpicker("refresh");
        }, 1000);
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Vahicle type data !",
          "error"
        );
      }
    );
  }

  GetPaidThrough() {
    $("#AccountNo").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Expense/GetPaidThrough",
        headers: {
          "Authorization": PaymentMadeComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: PaymentMadeComponent.that.CompanyId,
            param1: params.term,
          };
        },
        processResults: function (data, params) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Enter Account",
    });
  }

  GetTHCNoByCompany() {
    $("#SelectTHCTripNo").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/BillPayment/GetTHCNoByCompany",
        headers: {
          "Authorization": PaymentMadeComponent.that._appService.getAuthToken(),
        },
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: PaymentMadeComponent.that.CompanyId,
            param1: params.term,
          };
        },
        processResults: function (data, params) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Enter THC No",
    });
  }

  AdvanceSearch() {
    var BillId: any;
    var VendorId: any;
    var AccountNo: any;
    var THCNo: any;
    var fromDate: any;
    var toDate: any;
    var Financialyear: any;
    BillId =
      $("#SelectBillList").val().join(",") == ""
        ? null
        : $("#SelectBillList").val().join(",");
    VendorId =
      $("#CompanyData").val().join(",") == ""
        ? null
        : $("#CompanyData").val().join(",");
    AccountNo =
      $("#AccountNo").val().join(",") == ""
        ? null
        : $("#AccountNo").val().join(",");
    THCNo =
      $("#SelectTHCTripNo").val().join(",") == ""
        ? null
        : $("#SelectTHCTripNo").val().join(",");
    fromDate =
      this.GetFormattedDate("InvoiceFromDate", $("#InvoiceFromDate").val()) ==
        ""
        ? null
        : this.GetFormattedDate("InvoiceFromDate", $("#InvoiceFromDate").val());
    toDate =
      this.GetFormattedDate("InvoiceToDate", $("#InvoiceToDate").val()) == ""
        ? null
        : this.GetFormattedDate("InvoiceToDate", $("#InvoiceToDate").val());
    Financialyear =
      $("#id_ddlFinancialyear").val() == ""
        ? null
        : $("#id_ddlFinancialyear").val();

    if (
      BillId == null &&
      VendorId == null &&
      AccountNo == null &&
      THCNo == null &&
      fromDate == null &&
      toDate == null &&
      Financialyear == null
    ) {
      this.toastr.error("Please apply any filter  !", "error");
    } else {
      if (this.datatable) {
        this.selectedCard = "Draft";
        this.datatable.destroy();
        this.GetBillPaymentList();
      }
      $("#SalesInvoiceAdvanceSearch").modal("hide");
    }
  }

  clearAdvanceSearch() {
    $("#SelectBillList").val("");
    $("#CompanyData").val("");
    $("#SelectTHCTripNo").val("");
    $("#AccountNo").val("");
    $("#InvoiceFromDate").val("").datepicker("update");
    $("#InvoiceToDate").val("").datepicker("update");
    $("#id_ddlFinancialyear").val("");
    $("#SalesInvoiceAdvanceSearch").modal("hide");
    if (this.datatable) {
      this.selectedCard = "Draft";
      this.datatable.destroy();
      this.GetBillPaymentList();
    }
  }
  //end

  //added by vithujan 06-02-2023
  onShowShortcut() {
    $("#ShortcutKeys").modal("show");
    PaymentMadeComponent.that.TransactionType = "PaymentMade";

    if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
      PaymentMadeComponent.that.ModalType = "A";
    } else {
      PaymentMadeComponent.that.ModalType = "B";
    }
  }

  showHelpMenu() {
    document.addEventListener("keydown", function (zEvent) {
      if (zEvent.altKey && zEvent.key === "s") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == true) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.SavePaymentReceipt();
        }
      }
      if (zEvent.altKey && zEvent.key === "a") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == true) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.AuthorizeBillPayment();
        } else {
          zEvent.preventDefault();
          PaymentMadeComponent.that.OnNewPayment("advancePayment");
        }
      }
      if (zEvent.altKey && zEvent.key === "o") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == true) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.PostBillPayment();
        }
      }
      if (zEvent.altKey && zEvent.key === "p") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == true) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.GetPrintData(
            PaymentMadeComponent.that.PaymentId
          );
        }
      }
      if (zEvent.altKey && zEvent.key === "y") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == true) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.GetPrintDetailData(
            PaymentMadeComponent.that.PaymentId
          );
        }
      }
      if (zEvent.altKey && zEvent.key === "d") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.SearchStatus("Draft");
        } else {
          zEvent.preventDefault();
          if (PaymentMadeComponent.that.isDelete == false) {
            PaymentMadeComponent.that.DeletePaymentsPermanentlyById(
              PaymentMadeComponent.that.PaymentData.Id
            );
          }
        }
      }
      if (zEvent.altKey && zEvent.key === "z") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.SearchStatus("Authorized");
        }
      }
      if (zEvent.altKey && zEvent.key === "p") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.SearchStatus("Posted");
        }
      }
      if (zEvent.altKey && zEvent.key === "x") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.SearchStatus("Deleted");
        } else {
          zEvent.preventDefault();
          PaymentMadeComponent.that.DeleteBillPaymentById(
            PaymentMadeComponent.that.PaymentData.Id,
            "Detail"
          );
        }
      }
      if (zEvent.altKey && zEvent.key === "f") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == true) {
          zEvent.preventDefault();
          document.getElementById("BillNumber").focus();
        }
      }
      if (zEvent.altKey && zEvent.key === "b") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == true) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.OnAddBill();
        }
      }
      if (zEvent.altKey && zEvent.key === "m") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == true) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.OnSelectBill();
        }
      }
      if (zEvent.altKey && zEvent.key === "n") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.OnNewPayment("againstBill");
        }
      }
      if (zEvent.altKey && zEvent.key === "l") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.DownloadPaymentAdvice();
        }
      }
      if (zEvent.key === "F12") {
        if (
          PaymentMadeComponent.that.showPaymentMadeDetails == true &&
          PaymentMadeComponent.that.ShowAttachment == true
        ) {
          zEvent.preventDefault();
          $("#PaymentAttchment").modal("show");
        }
      }
      if (zEvent.key === "F1") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.onShowShortcut();
      }
      if (zEvent.key === "F2") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.clearAdvanceSearch();
        }
      }
      if (zEvent.key === "F5") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.showAdvanceSearch();
        }
      }
      if (zEvent.key === "F8") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          document.getElementById("SearchValue").focus();
        }
      }
      if (zEvent.key === "Escape") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == true) {
          if (document.body.className.indexOf("modal-open") !== -1) {
          } else {
            zEvent.preventDefault();
            PaymentMadeComponent.that.OnGoBack();
            setTimeout(() => {
              var rows = PaymentMadeComponent.that.datatable;
              rows.rows(".m-datatable__row");
              PaymentMadeComponent.that.totalRowsCount = rows.nodes().length;
            }, 2000);
            PaymentMadeComponent.that.rowIndex = -1;
          }
        }
      }
      if (zEvent.key === "ArrowDown") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();

          if (PaymentMadeComponent.that.rowIndex < -1) {
            PaymentMadeComponent.that.rowIndex = -1;
          }
          PaymentMadeComponent.that.rowIndex =
            PaymentMadeComponent.that.rowIndex + 1;
          if (
            PaymentMadeComponent.that.rowIndex >=
            PaymentMadeComponent.that.totalRowsCount
          ) {
            PaymentMadeComponent.that.rowIndex =
              PaymentMadeComponent.that.totalRowsCount - 1;
          }

          $(".m-datatable__table > tbody > tr")
            .eq(PaymentMadeComponent.that.rowIndex)
            .removeClass("m-datatable__row--even");
          $(".m-datatable__table > tbody > tr")
            .eq(PaymentMadeComponent.that.rowIndex - 1)
            .addClass("default-color");
          $(".m-datatable__table > tbody > tr")
            .eq(PaymentMadeComponent.that.rowIndex)
            .removeClass("default-color");
          $(".m-datatable__table > tbody > tr")
            .eq(PaymentMadeComponent.that.rowIndex)
            .addClass("highlight");
          window.scrollBy(0, 50);
        }
      }
      if (zEvent.key === "ArrowUp") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          PaymentMadeComponent.that.rowIndex =
            PaymentMadeComponent.that.rowIndex - 1;
          if (PaymentMadeComponent.that.rowIndex <= 0)
            PaymentMadeComponent.that.rowIndex = 0;

          $(".m-datatable__table > tbody > tr")
            .eq(PaymentMadeComponent.that.rowIndex)
            .removeClass("m-datatable__row--even");
          $(".m-datatable__table > tbody > tr")
            .eq(PaymentMadeComponent.that.rowIndex + 1)
            .addClass("default-color");
          $(".m-datatable__table > tbody > tr")
            .eq(PaymentMadeComponent.that.rowIndex)
            .removeClass("default-color");
          $(".m-datatable__table > tbody > tr")
            .eq(PaymentMadeComponent.that.rowIndex)
            .addClass("highlight");
          window.scrollBy(0, -100);
        }
      }
      if (zEvent.key === "Enter") {
        if (PaymentMadeComponent.that.showPaymentMadeDetails == false) {
          zEvent.preventDefault();
          var rows = PaymentMadeComponent.that.datatable;
          rows.rows(".m-datatable__row");
          if (rows.nodes().length > 0) {
            $.each(rows.nodes(), function (i) {
              var keys = Object.keys(rows.nodes()[i]);
              var data: any = {};
              data = rows.nodes()[i][keys[0]].obj;
              if (i == PaymentMadeComponent.that.rowIndex) {
                PaymentMadeComponent.that.showPaymentMadeList = false;
                PaymentMadeComponent.that.showPaymentMadeDetails = true;
                PaymentMadeComponent.that.GetBillPaymentById(data.Id);
              }
            });
          }
        }
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "p") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/PendingConsignments");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "s") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/SalesInvoice");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "r") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/PaymentReceived/list");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "j") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/CashReceipt");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "l") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/PendingBills");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "b") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/Bills");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "e") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/Expense");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "q") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/PaymentRequest");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "m") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/PaymentMade/list");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "h") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/SchedulePayment");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "i") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/ByVehicle");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "w") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/network/list");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "a") {
        zEvent.preventDefault();
        PaymentMadeComponent.that.router.navigateByUrl("/BankAccounts");
      }
    });
  }
  //end

  //added by vithujan 21-04-2023
  FillBankStatementData() {
    $("#PaymentDate").datepicker(
      "setDate",
      this.datepipe.transform(this.BankStatementData.ValueDate, "dd/MM/yyyy")
    );
    $("#PaymentMadeRemark").val(this.BankStatementData.TransactionRemarks);
    this.PaymentData.ReferenceNo = this.BankStatementData.ChequeNo_RefNo;

    //added by vithujan 18-07-2023
    this.PaymentData.BankCharges = this.BankStatementData.BankCharges;
  }
  //end

  openNetworkModel() {
    this.isShowOtherModel = "NetwrokModel";
    setTimeout(() => {
      this.isShowParentClose = false;
      this.ChildNetworkComponent.isOpenInOtherPage = true;
      this.ChildNetworkComponent.OnNewNetworkClick("false");
    }, 200);
  }

  NetworkModelClose() {
    this.isShowParentClose = true;
    this.isShowOtherModel = "NO";
  }

  //added by vithujan 22-07-2023
  DeleteJournalEntry() {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: !0,
      confirmButtonText: "Yes, delete it!",
    }).then(function (e) {
      if (e.value == true) {
        PaymentMadeComponent.that._appService
          .Delete("JournalEntry", "DeleteJournalEntryById", PaymentMadeComponent.that.PaymentData.Id)
          .subscribe(
            (response) => {
              PaymentMadeComponent.that.toastr.success(
                "Data Deleted Successfully !",
                "Success"
              );
              PaymentMadeComponent.that.GetJVSummaryData();
              PaymentMadeComponent.that.GetBillPaymentById(PaymentMadeComponent.that.PaymentData.Id);
            },
            (err) => {
              PaymentMadeComponent.that.toastr.error(
                err._body.replace(/"/g, ""),
                "error"
              );
              // JournalEntryComponent.journalEntryComponent.toastr.error("Error in deleting data !","error");
            }
          );
      }
    });
  }

  //added by maaria
  returnToBill() {
    localStorage.setItem("fromPayment", "true");
    this.router.navigateByUrl('/Bills');
  }
  //end

  // added by vithujan 19-10-2023 - Siddarth
  SaveDeletedTransactionHistory(Id) {
    var obj: any = {};
    obj.TransactionId = Id;
    obj.TransactionType = 'BillPayment';
    obj.UserId = this.userId;

    this._appService.Post("Common", "SaveDelTransactionHistory", obj).subscribe((response) => {
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  UploadAdvancePaymentFile(file) {
    Helpers.setLoading(true);
    this.AdvancePaymentFile = file.target.files[0];

    //--------------File True Type Validation ---------- added by vithujan 22-09-2022
    var fileReader = new FileReader();
    var isValidFileType = true;
    fileReader.onloadend = function (e: any) {
      var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
      var header = "";

      for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
      if (header.toUpperCase() != 'D0CF11E0' && header.toUpperCase() != '504B34') {
        PaymentMadeComponent.that.toastr.error(PaymentMadeComponent.that.translate.instant("SETTING.XLXOnly"), 'Error');
        $("#uploadConsignment").val("");
        isValidFileType = false;
        Helpers.setLoading(false);
        return false;
      }
    };
    fileReader.readAsArrayBuffer(this.AdvancePaymentFile);
    //----------------------------------------------

    setTimeout(() => {
      if (isValidFileType == true) {
        //#region file validation
        //--------------Filename Validation ---------- added by vithujan 23-09-2022
        var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
        if (!format.test(this.AdvancePaymentFile.name)) {
          this.toastr.error(this.translate.instant("SETTING.InvalidFile"), 'Error');
          $("#in_Reconciliation_file").val();
          Helpers.setLoading(false);
          return false;
        }
        //--------------File Type Validation ---------- added by vithujan 16-09-2022
        var meme_type = this.AdvancePaymentFile.type;
        if ((meme_type.toLowerCase() != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (meme_type.toLowerCase() != "application/vnd.ms-excel")) {
          this.toastr.error(this.translate.instant("SETTING.XLXOnly"), 'Error');
          $("#in_Reconciliation_file").val("");
          Helpers.setLoading(false);
          return;
        }

        //--------------Size Validation----------------
        var bytesize = this.AdvancePaymentFile.size;
        var kbsize: any = 0;
        kbsize = (bytesize / 1000).toFixed(2);
        let IsFileSizeExceed = false;
        if (kbsize > 1024) {
          if (kbsize / 1024 > environment.maxFileSize) IsFileSizeExceed = true;
          else IsFileSizeExceed = false;
        }
        if (IsFileSizeExceed) {
          this.toastr.error(this.translate.instant("SETTING.FileSize"), 'Error');
          $("#in_Reconciliation_file").val("");
          Helpers.setLoading(false);
          return;
        }
        //----------------------------------------------
        //#endregion file validation

        var Extension = this.AdvancePaymentFile.name.split(".").pop().toLowerCase();
        if (Extension == "xls") {
          if (file.target.files && file.target.files[0]) {
            var fd = new FormData();
            if (fd.has("BP_AdvancePaymentfile")) {
              fd.set("BP_AdvancePaymentfile", this.AdvancePaymentFile);
            } else {
              fd.append("BP_AdvancePaymentfile", this.AdvancePaymentFile);
            }
            this.AdvancePaymentFile = {};
            const apiUrl = environment.apiUrl + "/api/BillPayment/bp_UploadAdvancePayment?CompanyId=" + this.CompanyId +
              "&UserId=" + this.userId;
            this.httpService.post(apiUrl, fd).subscribe(
              (response) => {
                if (response == "Ok") {
                  this.toastr.success("Data Upload Successfully !", "Success");
                  $("#m_datatable_PaymentMade").mDatatable().reload();
                } else {
                  this.DownloadFile(response);
                  this.toastr.error("Please check downloaded file...", "success");
                }
                $("#in_AdvancePayment_file").val("");
                Helpers.setLoading(false);
              },
              (err) => {
                $("#in_AdvancePayment_file").val("");
                Helpers.setLoading(false);
                swal(err.error);
              }
            );
          }
        } else {
          this.toastr.error("Please select excel only !", "error");
          Helpers.setLoading(false);
        }
      }
    }, 300);
  }
  // added by rahul
  isDisabled: boolean = false;
  get_IsCompanyDisable(Id) {

    this._appService.GetByOneParam('Sales', 'get_IsCompanyDisable', Id).subscribe(
      (response) => {
        console.log(response, 'get_IsCompanyDisable');
        if (response[0].IsActive == false || null) {
          this.isDisabled = true;
          this.toastr.error("Selected Driver is disabled, you are not allowed to generate Bill", 'Error')
        }
        else if (response[0].IsDisable == true) {
          this.isDisabled = true;
          this.toastr.error("Selected customer is disabled, you are not allowed to generate Bill", 'Error')
        }
        else {
          this.isDisabled = false
        }
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error")
      }
    )
  }
  //end

  //added by vithu 10-11-2025 - Siddarth
  otp: any = '';
  otpResponse: any = {};
  GenerateOTP() {
    Helpers.setLoading(true);
    if (!this.PaymentData.PaidFromAccountId){
      this.toastr.error('Please select paid account', 'Error');
      return;
    }

    var obj: any = {};
    obj.BillPaymantId = this.PaymentId;
    obj.PaymentNo = this.PaymentData.Prefix + this.PaymentData.PaymentNo;
    obj.UserId = this.userId;
    obj.CompanyId = this.CompanyId;
    obj.BankAccountId = this.PaymentData.PaidFromAccountId;
    obj.TransactionCategory = "Payment Made";

    this._appService
      .Post(
        "BillPayment",
        "GenerateOTPICICIBank",
        obj
      )
      .subscribe(
        (response) => {
          if (response != null) {
            var data = JSON.parse(response);

            if (data.RESPONSE == 'Success') {
              this.otpResponse = data;
              this.otp = "";
              $("#OTPScreen").modal('show');
            } else {
              this.toastr.error(data.Message, 'Error');
            }
          } else {
            this.toastr.error('Error while generating otp code!', 'Error');
          }
          Helpers.setLoading(false);
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
    Helpers.setLoading(false);
  }

  isSaving: boolean = false;
  submitOtp() {
    if (!this.otp) {
      this.toastr.error('Please enter opt code!', 'Error');
      return;
    }
    // if (this.otp != this.otpResponse.OTP) {
    //   this.toastr.error('OTP code does not match, enter valid otp!', 'Error');
    //   return;
    // }
    if (parseFloat(this.PaymentData.Amount) <= 0) {
      this.toastr.error('Amount should be grater than zero!', 'Error');
      return;
    }
    if (!this.PaymentData.PaidFromAccountId) {
      this.toastr.error('Please select paid account', 'Error');
      return;
    }
    if (!this.PaymentData.VendorId) {
      this.toastr.error('Please select vendor', 'Error');
      return;
    }

    Helpers.setLoading(true);
    this.isSaving = true;
    $("#btnOtpSubmit").prop("disabled", true);

    var obj: any = {};
    obj.BillPaymantId = this.PaymentId;
    obj.PaymentNo = this.PaymentData.Prefix + this.PaymentData.PaymentNo;
    obj.Amount = parseFloat(this.PaymentData.Amount);
    obj.PayeeName = this.PaymentData.VendorName;
    obj.Remarks = this.PaymentData.Remarks ? this.PaymentData.Remarks : "";
    obj.OTP = this.otp;
    obj.UserId = this.userId;
    obj.CompanyId = this.CompanyId;
    obj.BankAccountId = this.PaymentData.PaidFromAccountId;
    obj.VendorId = this.PaymentData.VendorId;
    obj.TransactionTypeId = this.PaymentData.TransactionTypeId;
    obj.TransactionCategory = "Payment Made";

    this._appService
      .Post(
        "BillPayment",
        "ProcessICICIBankTransactionAPI",
        obj
      )
      .subscribe(
        (response) => {
          if (response != null) {
            if (response.toLowerCase() === 'success') {
              this.toastr.success('Transaction success!', 'Success');
              this.PostPayment();
              $("#OTPScreen").modal('hide');
            } else {
              this.toastr.error(response, 'Error');
            }
          } else {
            this.toastr.error('Transaction Failed!', 'Error');
          }
          Helpers.setLoading(false);
          this.isSaving = false;
          $("#btnOtpSubmit").prop("disabled", false);
        },
        (err) => {
          this.isSaving = false;
          Helpers.setLoading(false);
          $("#btnOtpSubmit").prop("disabled", false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
    Helpers.setLoading(false);
    $("#btnOtpSubmit").prop("disabled", false);
  }

  TransactionTypes: any = [];
  GetTransactionTypes() {
    this._appService
      .GetById("Common", "GetLookByCategoryName", "Transaction Types")
      .subscribe(
        (response) => {
          this.TransactionTypes = response;
          setTimeout(() => {
            (<any>$("#TransactionType")).selectpicker("refresh");
          }, 300);
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  BankApiLogs: any = [];
  ShowBankApiLog_bp() {
    if ($("#btnShowBankApiLog_bp")[0].classList.value == "fa fa-plus") {
      $("#btnShowBankApiLog_bp").removeClass("fa-plus");
      $("#btnShowBankApiLog_bp").addClass("fa-minus");
      $("#ShowBankApiLog_bp").slideToggle();
    } else {
      $("#btnShowBankApiLog_bp").addClass("fa-plus");
      $("#btnShowBankApiLog_bp").removeClass("fa-minus");
      $("#ShowBankApiLog_bp").slideToggle();
    }
    var Id = this.PaymentData.Id;
    var obj: any = {};
    obj.ReferenceId = Id;
    obj.CompanyId = this.CompanyId;
    obj.TransactionType = "Payment Made";

    if (this.PaymentData.Id != null && this.PaymentData.Id != undefined) {
      this._appService
        .Post("BillPayment", "GetBankApiLogsByPaymentNo", obj)
        .subscribe(
          (response) => {
            this.BankApiLogs = response;
          },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
    }
  }
}
